import React, {FC} from 'react'
import {ItemTop5Interface, useReport} from '../../../@types'

type StatsItemProps = {
    title: string
    array: ItemTop5Interface[]
}

const StatsItem: FC<StatsItemProps> = ({title, array}) => {

    const fakeArray = Array.from(Array(5).keys())
    const {
        administration: {
            color: {
                primary_color,
            },
        },
    } = useReport()

    return (
        <>
            <div className="d-flex flex-column mb-4">
                <span className="fs-4 fw-bold text-white">Top 5</span>
                <span className="fs-5 fw-bold text-white">{title}</span>
            </div>

            {
                !array.length ? (
                    <>
                        {
                            fakeArray.map((index) => (
                                <div className="card mb-3" key={index}>
                                    <div className="card-body py-5 ">
                                        <div className="bg-light-dark h-20px" />
                                    </div>
                                </div>
                            ))
                        }
                    </>
                ) : (
                    <>
                        {array.map((item, index) => (
                            <div className="card mb-3" key={index}>
                                <div className="card-body p-5">
                                    <div className="d-flex justify-content-between align-items-end">
                                        <span style={{color: primary_color}}>{item.text}</span>
                                        <span className="fs-9" style={{color: primary_color}}>({item.sessions})</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </>
                )

            }

        </>
    )
}

export {StatsItem}